<template>
  <span>{{ value | date }}</span>
</template>

<script>
export default {
  name: "DateValue",
  props: {
    value: {},
  }
}
</script>

<style scoped>

</style>
